export const REQUEST_TYPES = {
  EXPENSE: "expenses",
  TRAVEL: "travel",
  EUROCARD: "corporate card",
  CREDIT_CARD: "creditcard",
  AMEX_BTA: "amexbta",
};
